export const TEACHER_INACTIVATION_REASON = [
  'DUPLICATE_TEACHER_ENTRY',
  'TRANSFERRED_TO_ANOTHER_INSTITUTION',
  'RESIGNED_FROM_INSTITUTION',
  'RETIRED',
] as const;

export const TEACHER_INACTIVATION_REASON_LABELS: Record<
  (typeof TEACHER_INACTIVATION_REASON)[number],
  string
> = {
  DUPLICATE_TEACHER_ENTRY: 'Duplicate entry',
  TRANSFERRED_TO_ANOTHER_INSTITUTION: 'Transferred to another institution',
  RESIGNED_FROM_INSTITUTION: 'Resigned',
  RETIRED: 'Retired',
};

export const TEACHER_INACTIVATION_PAGE_SIZE = 20;

export const TEACHER_INACTIVATION_SEARCH_PLACEHOLDER = 'Teacher, mobile, institute, Code, EIIN, ZM';

export const TEACHER_INACTIVATION_REVIEW_SUBJECT = 'request';

export const TEACHER_INACTIVATION_LIST_PATH = '/settings/teacher-inactivations';
